<div id="top"></div>

<ng-container *ngIf="vm$ | async as vm">
    <div fxLayout="column">
        <div class="section-heading" fxLayout="row" fxLayoutAlign="start center">
            <h6 fxFlexOffset="20" fxFlexOffset.lt-md="5">News</h6>
        </div>
        <div class="section-content" fxLayout="row">
            <div class="w-100" fxLayout="row" fxLayoutAlign="center start">
                <div class="article" fxFlex="60" fxFlex.sm="90" fxFlex.xs="92" fxLayout="column">
                    <div class="title">
                        <h2>{{ vm.title }}</h2>
                    </div>
                    <div class="date-subtitle">
                        {{ vm.updatedOn || vm.creationDate | date : 'yyyy-MM-dd' }}
                    </div>
                    <div class="article-body">
                        <div [innerHTML]="vm.content | htmlContentCleanup | safe : 'html'"></div>
                    </div>
                    <div class="article-attachment">
                        <hr />
                        <h2 *ngIf="vm.attachmentsList.length > 0">Attachments</h2>
                        <ul *ngFor="let attachment of vm.attachmentsList">
                            <li>
                                <a [href]="attachment.url | safe : 'url'">
                                    {{ attachment.fileName }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <app-scroll-top></app-scroll-top>
        <div fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="12px">
            <div fxFlex="60" fxFlex.sm="90" fxFlex.xs="92" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="24px">
                <app-news-hero-card ngClass.gt-sm="hero-card" fxFlexFill [item]="vm.newsEnriched[0]"></app-news-hero-card>
                <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutAlign.lt-md="start stretch" fxLayoutGap.lt-md="24px" fxLayoutAlign="space-between stretch">
                    <div *ngFor="let item of vm.newsEnriched | slice : 1 : 4; let i = index" fxFlex="30%" fxFlex.sm fxLayout="column" fxLayoutAlign="start stretch">
                        <app-news-card class="h-100" [item]="item"></app-news-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
